<template>
    <div class="error-container">
        <div class="error">
            <div class="error-inner">
                <h2 class="title">404</h2>
                <p class="text">对不起,我们找不到这个页面</p>
                <a :href="indexUrl"><img src="../assets/images/logo-dark.svg" alt=""></a>
            </div>
        </div>
    </div>
</template>
<script>
import api from "@/api/api"
export default {
    name: 'error',
    data() {
        return {
            indexUrl: ''
        };
    },
    created() {
        this.getIndex()
    },
    methods: {
        getIndex() {
            api.base.index().then(res => {
                if (res.data.code == 200) {
                    this.indexUrl = res.data.data.webIndexPath
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
.error-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.error {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 6.8rem;
  height: 6.8rem;
  background-color: #fff;
  border-radius: 50%;
  text-align: center;
  display: table;
}
.error-inner {
  display: table-cell;
  vertical-align: middle;
}
.title {
  font-size: 80px;
  margin-bottom: 20px;
  color: #f8f8f8;
}
.text {
  font-size: 20px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/Error.vue